/**
 * Centralised category configuration — single source of truth.
 * Used by TrendingFeed, HomePage, and anywhere categories are referenced.
 */

export const FREE_CATEGORIES = [
  { key: 'for-you', label: 'YOUR PULSE', emoji: '\u2728', color: '#8B5CF6', bg: '#7C3AED', activeBg: 'linear-gradient(135deg, #8B5CF6, #6D28D9)' },
  { key: 'technology', label: 'TECH', emoji: '\u26A1', color: '#2563EB', bg: '#EFF6FF', activeBg: '#2563EB' },
  { key: 'politics', label: 'POLITICS', emoji: '\uD83C\uDFDB\uFE0F', color: '#B91C1C', bg: '#FEF2F2', activeBg: '#B91C1C' },
  { key: 'finance', label: 'FINANCE', emoji: '\uD83D\uDCC8', color: '#059669', bg: '#ECFDF5', activeBg: '#059669' },
  { key: 'economy', label: 'ECONOMY', emoji: '\uD83D\uDCB0', color: '#D97706', bg: '#FFFBEB', activeBg: '#D97706' },
  { key: 'internet_culture', label: 'CULTURE', emoji: '\uD83C\uDF10', color: '#F43F5E', bg: '#FFF1F2', activeBg: '#F43F5E' },
  { key: 'entertainment', label: 'CELEB', emoji: '\uD83C\uDFAC', color: '#DB2777', bg: '#FDF2F8', activeBg: '#DB2777' },
  { key: 'lifestyle', label: 'STYLE', emoji: '\u2728', color: '#9333EA', bg: '#FAF5FF', activeBg: '#9333EA' },
  { key: 'sports', label: 'SPORTS', emoji: '\u26BD', color: '#16A34A', bg: '#F0FDF4', activeBg: '#16A34A' },
  { key: 'ai', label: 'AI', emoji: '\uD83E\uDD16', color: '#7C3AED', bg: '#F5F3FF', activeBg: '#7C3AED' },
];

export const PREMIUM_CATEGORIES = [
  { key: 'crypto', label: 'CRYPTO', emoji: '\uD83E\uDE99', color: '#EA580C', bg: '#FFF7ED', activeBg: '#EA580C' },
  { key: 'sports_betting', label: 'SPORTS BETS', emoji: '\uD83C\uDFB0', color: '#16A34A', bg: '#F0FDF4', activeBg: '#16A34A' },
  { key: 'stocks', label: 'STOCKS', emoji: '\uD83D\uDCC8', color: '#059669', bg: '#ECFDF5', activeBg: '#059669' },
  { key: 'options_trading', label: 'OPTIONS', emoji: '\uD83D\uDCCA', color: '#4F46E5', bg: '#EEF2FF', activeBg: '#4F46E5' },
  { key: 'ecommerce', label: 'E-COMMERCE', emoji: '\uD83D\uDED2', color: '#0891B2', bg: '#ECFEFF', activeBg: '#0891B2' },
  { key: 'dropshipping', label: 'TRENDS', emoji: '\uD83D\uDE80', color: '#C026D3', bg: '#FDF4FF', activeBg: '#C026D3' },
  { key: 'forex', label: 'FOREX', emoji: '\uD83D\uDCB1', color: '#0284C7', bg: '#F0F9FF', activeBg: '#0284C7' },
  { key: 'commodities', label: 'COMMODITIES', emoji: '\uD83E\uDD47', color: '#CA8A04', bg: '#FEFCE8', activeBg: '#CA8A04' },
  { key: 'property', label: 'PROPERTY', emoji: '\uD83C\uDFE0', color: '#0D9488', bg: '#F0FDFA', activeBg: '#0D9488' },
  { key: 'small_business', label: 'BIZ', emoji: '\uD83C\uDFEA', color: '#65A30D', bg: '#F7FEE7', activeBg: '#65A30D' },
];

export const PREMIUM_TRADERS_CATEGORIES = [
  { key: 'fantasy_sports', label: 'FANTASY', emoji: '\uD83C\uDFC6', color: '#0D9488', bg: '#F0FDFA', activeBg: '#0D9488' },
  { key: 'sneakers_streetwear', label: 'SNEAKERS & STREETWEAR', emoji: '\uD83D\uDC5F', color: '#E11D48', bg: '#FFF1F2', activeBg: '#E11D48' },
  { key: 'fashion_luxury', label: 'FASHION & LUXURY', emoji: '\uD83D\uDC5C', color: '#9333EA', bg: '#FAF5FF', activeBg: '#9333EA' },
  { key: 'trading_cards', label: 'TRADING CARDS', emoji: '\uD83C\uDCCF', color: '#2563EB', bg: '#EFF6FF', activeBg: '#2563EB' },
  { key: 'gaming_items', label: 'GAMING ITEMS & SKINS', emoji: '\uD83C\uDFAE', color: '#7C3AED', bg: '#F5F3FF', activeBg: '#7C3AED' },
  { key: 'collectibles', label: 'COLLECTIBLES & MEMORABILIA', emoji: '\uD83C\uDFC6', color: '#CA8A04', bg: '#FEFCE8', activeBg: '#CA8A04' },
  { key: 'toys_popculture', label: 'TOYS & POP CULTURE', emoji: '\uD83E\uDDE8', color: '#EA580C', bg: '#FFF7ED', activeBg: '#EA580C' },
  { key: 'collectors', label: 'FLIPS', emoji: '\uD83D\uDC5F', color: '#E11D48', bg: '#FFF1F2', activeBg: '#E11D48' },
];

export const PREMIUM_TIKTOK_SHOP_CATEGORIES = [
  { key: 'tiktok_trending', label: 'TRENDING', emoji: '\uD83D\uDD25', color: '#E11D48', bg: '#FFF1F2', activeBg: '#E11D48' },
  { key: 'shopify_trends', label: 'SHOPIFY', emoji: '\uD83D\uDED2', color: '#16A34A', bg: '#F0FDF4', activeBg: '#16A34A' },
  { key: 'amazon_bsr', label: 'AMAZON BSR', emoji: '\uD83D\uDCE6', color: '#D97706', bg: '#FFFBEB', activeBg: '#D97706' },
  { key: 'tiktok_convergence', label: 'CONVERGENCE', emoji: '\uD83C\uDFAF', color: '#7C3AED', bg: '#F5F3FF', activeBg: '#7C3AED' },
];

export const ALL_CATEGORIES = [...FREE_CATEGORIES, ...PREMIUM_CATEGORIES, ...PREMIUM_TRADERS_CATEGORIES, ...PREMIUM_TIKTOK_SHOP_CATEGORIES];
export const PREMIUM_KEYS = new Set([...PREMIUM_CATEGORIES, ...PREMIUM_TRADERS_CATEGORIES, ...PREMIUM_TIKTOK_SHOP_CATEGORIES].map(c => c.key));

export const CARD_GRADIENTS = {
  finance:      { from: '#2563EB', to: '#60A5FA', accent: '#93C5FD' },
  technology:   { from: '#EA580C', to: '#FB923C', accent: '#FDBA74' },
  ai:           { from: '#0F766E', to: '#14B8A6', accent: '#5EEAD4' },
  economy:      { from: '#B45309', to: '#F59E0B', accent: '#FCD34D' },
  crypto:       { from: '#7C3AED', to: '#A78BFA', accent: '#C4B5FD' },
  world_news:   { from: '#DC2626', to: '#EF4444', accent: '#FCA5A5' },
  internet_culture: { from: '#BE123C', to: '#F43F5E', accent: '#FDA4AF' },
  politics:     { from: '#1D4ED8', to: '#3B82F6', accent: '#93C5FD' },
  entertainment:{ from: '#BE185D', to: '#EC4899', accent: '#F9A8D4' },
  lifestyle:    { from: '#7E22CE', to: '#A855F7', accent: '#D8B4FE' },
  sports:       { from: '#15803D', to: '#22C55E', accent: '#86EFAC' },
  sports_betting:{ from: '#166534', to: '#16A34A', accent: '#4ADE80' },
  fantasy_sports:{ from: '#115E59', to: '#0D9488', accent: '#5EEAD4' },
  options_trading:{ from: '#3730A3', to: '#4F46E5', accent: '#818CF8' },
  stocks:        { from: '#047857', to: '#059669', accent: '#34D399' },
  property:      { from: '#0F766E', to: '#0D9488', accent: '#5EEAD4' },
  ecommerce:    { from: '#155E75', to: '#0891B2', accent: '#22D3EE' },
  dropshipping: { from: '#86198F', to: '#C026D3', accent: '#E879F9' },
  forex:        { from: '#075985', to: '#0284C7', accent: '#38BDF8' },
  commodities:  { from: '#854D0E', to: '#CA8A04', accent: '#FACC15' },
  collectors:   { from: '#9F1239', to: '#E11D48', accent: '#FB7185' },
  small_business:{ from: '#3F6212', to: '#65A30D', accent: '#A3E635' },
  sneakers_streetwear: { from: '#9F1239', to: '#E11D48', accent: '#FB7185' },
  fashion_luxury:{ from: '#6B21A8', to: '#9333EA', accent: '#C084FC' },
  trading_cards:{ from: '#1E40AF', to: '#2563EB', accent: '#60A5FA' },
  gaming_items: { from: '#5B21B6', to: '#7C3AED', accent: '#A78BFA' },
  collectibles: { from: '#854D0E', to: '#CA8A04', accent: '#FACC15' },
  toys_popculture:{ from: '#C2410C', to: '#EA580C', accent: '#FB923C' },
  tiktok_trending:{ from: '#E11D48', to: '#F43F5E', accent: '#FDA4AF' },
  shopify_trends: { from: '#15803D', to: '#16A34A', accent: '#4ADE80' },
  amazon_bsr:     { from: '#B45309', to: '#D97706', accent: '#FCD34D' },
  tiktok_convergence:{ from: '#7C3AED', to: '#A855F7', accent: '#D8B4FE' },
  tiktok_hooks:   { from: '#DB2777', to: '#EC4899', accent: '#F9A8D4' },
};

export const REGIONS = [
  { key: 'all', label: 'All' },
  { key: 'US', label: 'US' },
  { key: 'GB', label: 'UK' },
  { key: 'IN', label: 'India' },
];

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_web-pulse-4/artifacts/i5z1wfjq_WTFH%20logo.png';
